import { onMounted, useStore } from '@nuxtjs/composition-api'
import { getDeviceId } from '../modules/client/utilities'

export default function useDeviceId() {
  const store = useStore()
  onMounted(() => {
    if (window.requestIdleCallback) {
      window.requestIdleCallback(() => {
        getDeviceId().then(deviceId => {
          store.commit('DEVICE_ID', deviceId)
        })
      })
    } else {
      setTimeout(() => {
        getDeviceId().then(deviceId => {
          store.commit('DEVICE_ID', deviceId)
        })
      }, 500)
    }
  })
}
